import $ from 'jquery';
import config from 'lib/config';
import * as Utils from 'lib/utils';

const W = window;
const $D = $(document);

if (!$.events) $.events = { ui: [], auth: [] };

$.onAuth = $.fn.onAuth = function (handler) {
  $.events.auth.push([this, handler]);
  return this;
};

$.setAuth = async (auth, init) => {
  W.AUTH = Utils.freeze(auth);
  W.PREFERENCES = Utils.freeze(auth?.user?.preferences || {});
  W.SETTINGS = Utils.freeze({
    website: auth.website?.settings || {},
    user: auth?.user?.settings || {},
  });

  console.groupCollapsed('🔧 AUTH');
  console.log('API', W.API);
  console.log('AUTH', W.AUTH);
  console.log('SETTINGS', W.SETTINGS);
  console.log('PREFERENCES', W.PREFERENCES);
  console.groupEnd();

  const { impersonated, authenticated, user } = auth;

  if (authenticated) {
    const sms_approved = W.SETTINGS.website.sms_approved;

    if (!init) $.reconnect();
    if (!impersonated) {
      if (user.force_password_change) {
        await $.modal('/password-change', { id: 'change-password', static: true });
        return;
      }

      if (user.needs_terms?.length) {
        await $.modal('/accept-terms', { id: 'terms', static: true, size: 'lg' });
        return;
      }

      if (!init && ((user.email && !user.email.is_confirmed) || (sms_approved && user.sms && !user.sms.is_confirmed))) {
        const result = await $.modal('/confirm-notify', { id: 'confirm-notify', color: 'warning', size: 'lg' });

        if (result) {
          location.href = '/user/preferences';
          return;
        }
      }
    }

    if (config.dev || Utils.get(auth, 'user.admin.is_admin', false)) {
      const observer = new PerformanceObserver(list => {
        for (const entry of list.getEntries()) {
          if (!entry.hadRecentInput) {
            console.groupCollapsed('⇓ LAYOUT-SHIFT');
            console.log('VALUE', entry.value);
            if (entry.sources) for (const { node } of entry.sources) console.log('ELEMENT', node);
            console.groupEnd();
          }
        }
      });

      observer.observe({ type: 'layout-shift', buffered: true });
    }
  }

  $('body').toggleClass('not-authenticated', !authenticated).toggleClass('authenticated', authenticated);

  if (authenticated) {
    const sounds = $.storage.get('sounds');

    if (auth.user.admin.is_admin) $('.admin').removeClass('d-none');

    if (auth.website.settings.allow_consignor_lot_mgmt && auth.user.settings.can_add_manage_items) {
      $('.auth-user').append(`
        <a class="dropdown-item btn-selling" href="${Utils.baseUri('/user/seller/manage')}">
          <i class="fas fa-boxes-stacked fa-fw"></i>
          <span>Add / Manage Items</span>
        </a>
      `);

      $(`
        <a class="app-header-item" href="${Utils.baseUri('/user/seller/manage')}">
          <i class="fas fa-boxes-stacked"></i>
          <span>Selling</span>
        </a>
      `).insertAfter('.app-buttons.authenticated .app-header-item.btn-watchlist');
    } else
      $('.auth-user').append(`
        <a class="dropdown-item" href="${Utils.baseUri('/user/seller/selling')}">
          <i class="fas fa-boxes-stacked fa-fw"></i>
          <span>Items Selling</span>
        </a>
      `);

    if (auth.user.settings.can_approve_items)
      $('.auth-user').append(`
        <a class="dropdown-item" href="${Utils.baseUri('/user/seller/selling?status=subject-to-approval')}">
          <i class="fas fa-check-to-slot fa-fw"></i>
          <span>Pending Approval</span>
          <div class="badge badge-warning badge-pill badge-pending-approval d-none"></div>
        </a>
      `);

    $('.btn-profile span').text(`${user.first_name} ${user.last_name}`);
    $('.btn-sounds')
      .toggleClass('d-none', !user.preferences?.browser?.sounds)
      .find('.fa')
      .removeClass('fa-volume fa-volume-slash')
      .addClass(`fa-volume${sounds === 'muted' ? '-slash' : ''}`);
  }

  if (init !== true) $D.triggerHandler('auth:change');
};

$.initAuth = async () => {
  $.setAuth($.unpack(W.AUTH), true);
};
